import { render, staticRenderFns } from "./AlbumDetails.vue?vue&type=template&id=56dfe7fc&scoped=true"
import script from "./AlbumDetails.vue?vue&type=script&lang=js"
export * from "./AlbumDetails.vue?vue&type=script&lang=js"
import style0 from "./AlbumDetails.vue?vue&type=style&index=0&id=56dfe7fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dfe7fc",
  null
  
)

export default component.exports